import { i18n } from '@/plugins/i18n'
import { check } from '@/plugins/helper'
import Vue from '../../main.js'

const getDefaultState = () => {
    return {
        customerId                          : 0,
        customerAlias                       : "",
        customerAliasTemp                   : "",
        customerName                        : "",
        gender                              : "",
        corporate                           : "",
        vip                                 : false,
        dob                                 : "",
        email                               : "",
        newEmail                            : "",
        emailverified                       : false,
        postalCode                          : "",
        mobile                              : "",
        mobileCountryCode                   : "",
        mobileCountryId                     : 0,
        nationalityId                       : 0,
        nationality                         : "",
        statusId                            : 0,
        regRetailAgentId                    : 0,
        regRetailBranchId                   : 0,
        isPOA                               : false,
        minOutstandingAmt                   : 0,
        maxOutstandingAmt                   : 0,
        totalUnclearAmount                  : 0,
        treasuryReceiptAmountLimit          : 0,
        onlineTreasuryReceiptAmountLimit    : 0,
        storedValue                         : false,
        lastAcceptedTncVersion              : "",
        qrCode                              : {metadata:"", base64:""},
        occupation                          : "",
        numOfBeneficiary                    : 0,
        eKYCDocStatus                       : -1,
        eKYCDoc                             : -1,
        eKYCPOAStatus                       : -1,
        eKYCSelfieStatus                    : -1,
        customerDocumentList                : [],
        svStatusId                          : 0,
        sourceRemittance                    : "",
        inactiveWallet                      : false,
        isCustomerVerified                  : false,
        paymentEKYC                         : false,
        routerTo                            : "",
        retailBranchId                      : 0,
        resetPasswordId                     : 0,
        resetPasswordFpvc                   : "",
        newPassword                         : "",
        occupationList                      : [],
        oldEmail                            : "",
        isOldEmailUpdated                   : false,
        evcExpiryDate                       : "",
        dateCreated                         : "",
        lastFxCalcCurrencyId                : "0",


        update:{
            customerName                    : "",
            customerAlias                   : "",
            nationalityId                   : 0,
            nationality                     : "",
            gender                          : "",
            dob                             : "",
            idTypeId                        : 0,
            idType                          : "",
            idNo                            : "",
            occupation                      : "",
            employmentSector                : "",
            industryList                    : [],
            tempCurrMobileCountryCodeId     : 189,
            tempCurrMobileCountryCodeIdd    : "+65",
            tempCurrMobileNo                : "",
            tempNewMobileCountryCodeId      : 189,
            tempNewMobileCountryCodeIdd     : "+65",
            tempNewMobileNo                 : "",
            tempNewEmail                    : "",
            tempConfirmNewEmail             : "",
        }, 

        isValidFullname                     : false,
        isValidAlias                        : false,
        isValidNationality                  : false,
        isValidGender                       : false,
        isValidDob                          : false,
        isValidIdType                       : false,
        isValidIdNo                         : false,
        isValidOccupation                   : false,
        isValidEmploymentSector             : false,
        isValidCheckOnlySpecial             : false,
        isValidForm                         : false,
        isModifyAlias                       : false,

        notification:{
            inboxList               :[],
            unreadInboxList         : [],
            readInboxList           : [],
            hasMoreItems            : true,
            showLoadingBar          : false,
            allowInfinite           : true,
            lastItem                : 0,
            itemPerPage             : 10,
            loadingFirstItem        : true,
            isRead                  : 0,
            selectedMessageId       : 0,
        },

        latestTx                  : {},
        txDestList                : [],
        tempUpdateAccountToken    : "",
        tempUpdateAccountType     : 0,
        tempUpdateAccountData     : {},     
    }
}
const state = getDefaultState()

const getters = {
    updateDetails: (state) => {
        return state.update
    },
    customerName: (state) => {
        return state.customerName
    },
    customerAlias: (state) => {
        return state.customerAlias
    },
    customerAliasTemp: (state) => {
        return state.customerAliasTemp
    },
    statusId: (state) => {
        return state.statusId
    },
    email: (state) => {
        return state.email.replace(/^(.)(.*)(@.*)$/, (_, a, b, c) => a + b.replace(/./g, '*') + c);
    },
    emailVerified: (state) => {
        return state.emailverified
    },
    mobile: (state) => {
        return state.mobile.replace(/\d(?=\d{4})/g, "*");
    },
    mobileCountryId: (state) => {
        return state.mobileCountryId
    },
    mobileCountryCode: (state) => {
        return state.mobileCountryCode
    },
    nationality: (state) => {
        return state.nationality
    },
    nationalityId: (state) => {
        return state.nationalityId
    },
    dob: (state) => {
        return state.dob
    },
    gender: (state) => {
        if(state.gender=="M"){
          return "Male"
        }else if(state.gender=="F"){
          return "Female"
        }else{
            return ""
        }
    },
    sourceRemittance: (state) => {
        return state.sourceRemittance
    },
    occupation: (state) => {
        return state.occupation
    },
    retailBranchId: (state) => {
        return state.retailBranchId
    },
    resetPasswordId: (state) => {
        return state.resetPasswordId
    },
    resetPasswordFpvc: (state) => {
        return state.resetPasswordFpvc
    },
    newPassword: (state) => {
        return state.newPassword
    },
    occupationList: (state) => {
        return state.occupationList
    },

    update: (state) => {
        return state.update
    },
    isValidCheckOnlySpecial: (state) => {
        return state.isValidCheckOnlySpecial
    },
    isValidFullname: (state) => {
        return state.isValidFullname
    },
    isValidAlias: (state) => {
        return state.isValidAlias
    },
    isValidNationality: (state) => {
        return state.isValidNationality
    },
    isValidGender: (state) => {
        return state.isValidGender
    },
    isValidDob: (state) => {
        return state.isValidDob
    },
    isValidIdType: (state) => {
        return state.isValidIdType
    },
    isValidIdNo: (state) => {
        return state.isValidIdNo
    },
    isValidOccupation: (state) => {
        return state.isValidOccupation
    },
    isValidEmploymentSector: (state) => {
        return state.isValidEmploymentSector
    },
    isValidForm: (state) => {
        return state.isValidForm
    },
    oldEmail: (state) => {
        return state.oldEmail
    },
    isOldEmailUpdated: (state) => {
        return state.isOldEmailUpdated
    },
    isModifyAlias: (state) => {
        return state.isModifyAlias
    },
    notification: (state) => {
        return state.notification
    },
    latestTx: (state) => {
        return state.latestTx
    },
    dateCreated: (state) => {
        return state.dateCreated
    },
    lastFxCalcCurrencyId: (state) => {
        return state.lastFxCalcCurrencyId
    },
    txDestList: (state) => {
        return state.txDestList
    },
    tempUpdateAccountToken: (state) => {
        return state.tempUpdateAccountToken
    },
    tempUpdateAccountType: (state) => {
        return state.tempUpdateAccountType
    },
    tempUpdateAccountData: (state) => {
        return state.tempUpdateAccountData
    },
}

const actions = {
    resetCustomerState ({ commit }) {
        commit('resetCustomerState')
    },
    /* VALIDATE INPUT */
    async validateInput({ state, dispatch, commit }, inputEl) {
        let isValidInput           = false;
        //console.log("inputEl.id: "+inputEl.id);
        // FULLNAME
        if(inputEl.id === "fullname") {
            await dispatch('validateFullname', inputEl.value);
            isValidInput = state.isValidFullname;
            //Vue.setInputState(inputEl.id, isValidInput)
        }
        // CUSTOMER ALIAS
        else if(inputEl.id === "customerAlias") {
            await dispatch('validateAlias', inputEl.value);
            isValidInput = state.isValidAlias;
            //Vue.setInputState(inputEl.id, isValidInput)
        }
        // NATIONALITY
        else if(inputEl.id === "nationality") {
            let isValidNationality = state.update.nationalityId > 0;
            isValidInput = isValidNationality ? true : i18n.t('regis-nationality-empty');
            await commit('loadIsValidNationality', isValidInput);
        }
        // GENDER
        else if(inputEl.id === "gender") {
            let isValidGender = state.update.gender.trim() != "";
            isValidInput = isValidGender ? true : i18n.t('regis-gender-empty');
            await commit('loadIsValidGender', isValidInput);
        }
        // DOB
        else if(inputEl.id === "dob") {
            // const moment= require('moment');
            // const maxDate = moment().subtract(17, 'years').format('YYYY-MM-DD'); // MIN 17 y.o
            // const oldDob = moment(new Date(state.update.dob)).format('YYYY-MM-DD');
            // //console.log(oldDob+" ## "+maxDate)

            // if(oldDob > maxDate){ // < 17 y.o
            //     // SET TO DEFAULT
            //     await dispatch('setUpdateDob', '01-01-1950')
            // }

            console.log("DoB = "+state.update.dob)

            let isValidDob = state.update.dob.trim() != "";
            isValidInput = isValidDob ? true : i18n.t('reset-dob-empty');
            await commit('loadIsValidDob', isValidInput);
        }
        // ID TYPE
        else if(inputEl.id === "idType") {
            let isValidIdType = state.update.idTypeId > 0;
            isValidInput = isValidIdType ? true : i18n.t('ua-id-type-select-help');
            await commit('loadIsValidIdType', isValidInput);
            //await dispatch('validateIdentificationNo', state.update.idNo)
            await dispatch('validateInput', {id: 'idNo', value: state.update.idNo})                      
        }
        // ID NO
        else if(inputEl.id === "idNo") {
            await dispatch('validateIdentificationNo', state.update.idNo)
            isValidInput = state.isValidIdNo
        }
        // OCCUPATION
        else if(inputEl.id === "occupation") {
            console.log("validate occupation: "+state.update.occupation)
            //let isValidOccupation = state.update.occupation.trim() != "";
            let isValidOccupation = check.validateNullEquivalent(state.update.occupation.trim());
            console.log("isValidOccupation, "+state.update.occupation.trim()+": "+isValidOccupation)

            //isValidInput = isValidOccupation ? true : i18n.t('ua-occupation-empty');

            // min 2 chars and not null equivalent
            isValidInput = state.update.occupation.trim().length < 3 ? i18n.t('ua-occupation-empty') : isValidOccupation ? true : i18n.t('ua-occupation-null-equivalent');
            await commit('loadIsValidOccupation', isValidInput);
        }
        // EMPLOYMENT SECTOR
        else if(inputEl.id === "employment") {
            let isValidEmploymentSector = state.update.employmentSector.trim() != "";
            isValidInput = isValidEmploymentSector ? true : i18n.t('ua-employment-sector-empty');
            await commit('loadIsValidEmploymentSector', isValidInput);
        }
        else {
            //isValidInput = true;
        }

        await Vue.setInputState(inputEl.id, isValidInput);
        
        let isValid = state.isValidFullname == true && state.isValidNationality == true && state.isValidGender == true && state.isValidDob == true && state.isValidIdType == true && state.isValidIdNo == true && state.isValidOccupation == true && state.isValidEmploymentSector == true
        await dispatch('setIsValidForm', isValid);
        //console.log("isValidForm : "+isValid)
        //commit('loadIsValidForm', isValid);
        
    },
    /* END OF VALIDATE INPUT */

    async validateIdentificationNo({ commit, state }, value) {
      let idNo         = value != undefined ? value : '';
      let isValidInput = true;
      let inputState   = "";
      let msg          = "";

      
      if(idNo.trim() == ""){
        isValidInput = false;
        msg          = i18n.t('ua-id-no-help');
      }else{
          // 104 - SG. NATIONAL ID | 154 = SG. NATIONAL ID - PR | 102 - SG. Driver's License
          if((parseInt(state.update.idTypeId) === 104 || parseInt(state.update.idTypeId) === 154) || (parseInt(state.update.idTypeId) === 102 && parseInt(state.update.nationalityId) === 189)){
            isValidInput = check.validPattern("nric", idNo);

            if(idNo.trim().length < 9){
                msg = i18n.t('ua-doc-no-too-short')
            }else{
                if(!isValidInput){
                    msg = i18n.t('ua-doc-no-invalid')
                }
            }
          }
          // 103 - SG. Work Permit | 120 - SG. S.Pass | 133 - SG. Employment Pass | 136 - SG. Dependent Pass | 140 - SG. Long Term Visit Pass | 102 - SG. Driver's License
          else if(parseInt(state.update.idTypeId) === 103 || parseInt(state.update.idTypeId) === 120 || parseInt(state.update.idTypeId) === 133 || parseInt(state.update.idTypeId) === 136 || parseInt(state.update.idTypeId) === 140 || (parseInt(state.update.idTypeId) === 102 && parseInt(state.update.nationalityId) === 189)){
            isValidInput = check.validPattern("fin", idNo);

            if(idNo.trim().length < 9){
                msg = i18n.t('ua-doc-no-too-short')
            }else{
                if(!isValidInput){
                    msg = i18n.t('ua-doc-no-invalid')
                }
            }
          }else{
            isValidInput = idNo.trim() == "" ? false : true; // check.validPattern("documentid189", idNo);

            if(!isValidInput){
                msg          = i18n.t('ua-id-no-help');
            }
          }
      }

      inputState = isValidInput ? true : msg;
      
      await commit('loadIsValidIdNo', inputState);
    },

    validateFullname({ commit, dispatch }, value) {
        let fullName      = value != undefined ? value : '';
        let isValidInput  = true;
        let inputState    = "";

        let msg1          = i18n.t('ua-fullname-error1');
        let msg2          = i18n.t('ua-fullname-error2');
        let msg3          = i18n.t('ua-fullname-error3');
        


        dispatch('checkPreventOnlySpecial', fullName);
        let chkSpcResult = this.state.customer.isValidCheckOnlySpecial;
        if(chkSpcResult < 0) {
            isValidInput = false;
            switch(chkSpcResult) {
                case -1:
                    inputState = isValidInput ? true : msg1;
                    break;
                case -2:
                    inputState = isValidInput ? true : msg2;
                    break;
                case -3:
                    inputState = isValidInput ? true : msg3;
                    break;
            }
        } else {
            isValidInput = true;
            inputState   = true;
        }
        commit('loadIsValidFullname', inputState);
    },

    validateAlias({ commit, dispatch }, value) {
        let alias        = value != undefined ? value : '';
        let isValidInput  = true;
        let inputState    = true;

        let msg1          = i18n.t('regis-alias-error1');
        let msg2          = i18n.t('regis-alias-error2');
        let msg3          = i18n.t('regis-alias-error3');
        let msg4          = i18n.t('regis-alias-error4');
       

        dispatch('checkPreventOnlySpecial', alias);
        let chkSpcResult = this.state.customer.isValidCheckOnlySpecial;
        console.log(chkSpcResult)
        if(chkSpcResult < 0) {
            isValidInput = false;
            switch(chkSpcResult) {
                case -1:
                    inputState = isValidInput ? true : msg1;
                    break;
                case -2:
                    inputState = isValidInput ? true : msg2;
                    break;
                case -3:
                    inputState = isValidInput ? true : msg3;
                    break;
                case -4:
                    inputState = isValidInput ? true : msg4;
                    break;
            }
        }
        
        const profanityResult = check.isProfanity(value);
        if (profanityResult != null && profanityResult.isProfanity) {
            // dispatch('setCustomerAliasTemp', profanityResult.censored);
            inputState = i18n.t('regis-alias-error5');
        }
        commit('loadIsValidAlias', inputState);
    },

    checkPreventOnlySpecial({ state, commit }, value) {
        let specialList  = ['.', ',', '!', '!', '{ ', '}', '<', '>', '?', ':', ';', '\u2013', '\u2014', '-', '(', ')', '[', ']', '\'', '"', '\u2018', '\u0060', '\u2019', '\u201C', '\u201D', '^', '@', '~', '`', '$', '%', '*', '_', '|', '/', '&', '#'];
        let val          = value;
        let trimmedVal   = value.trim();
        let removedWhite = val.replace(/\s+/g,'');
        let len          = val.length, removedLen = removedWhite.length, trimmedLen = trimmedVal.length;
        let i            = 0, spcCount = 0, checkChar = 0;

        //console.log("isModifyAlias : "+state.isModifyAlias)

        if(len == 0) { // must not be empty!
            if(state.isModifyAlias == false){ // ALLOW EMPTY WHEN MODIFYING ALIAS
                commit('loadCheckPreventOnlySpecial', -1);
            }else{
                commit('loadCheckPreventOnlySpecial', 0);
            }
        } else if(trimmedLen > 50) { // max length = 50 chars
            commit('loadCheckPreventOnlySpecial', -4);
        } else if(removedLen == 0) { // considered error, because the value contains only white spaces.
            commit('loadCheckPreventOnlySpecial', -2);
        } else {
            spcCount = 0;
            for(i = 0; i < removedLen; i++) {
                checkChar = removedWhite.charAt(i);
                if(specialList.indexOf(checkChar)>-1) { // if in list of Special Character, add to count.
                    spcCount++;
                }
            }
            if(spcCount == removedLen) { // considered error, because the value contains only special characters.
                commit('loadCheckPreventOnlySpecial', -3);
            } else {
                commit('loadCheckPreventOnlySpecial', 0);
            }
        }
    },

    setUpdateCustomerName({ commit }, payload) { 
        commit('setUpdateCustomerName', payload);
    },

    setUpdateCustomerAlias({ commit }, payload) { 
        commit('setUpdateCustomerAlias', payload);
    },

    setUpdateNationality({ commit }, payload) { 
        commit('setUpdateNationality', payload);
    },

    setUpdateGender({ commit }, payload) { 
        commit('setUpdateGender', payload);
    },

    setUpdateDob({ commit }, payload) { 
        commit('setUpdateDob', payload);
    },

    setUpdateIdType({ commit }, payload) { 
        commit('setUpdateIdType', payload);
    },

    setUpdateIdNo({ commit }, payload) { 
        commit('setUpdateIdNo', payload);
    },

    setUpdateOccupation({ commit }, payload) { 
        commit('setUpdateOccupation', payload);
    },

    setUpdateEmploymentSector({ commit }, payload) { 
        commit('setUpdateEmploymentSector', payload);
    },

    setUpdateIndustryList({ commit }, payload) { 
        commit('setUpdateIndustryList', payload);
    },

    setCustomerName({ commit }, value) { 
        commit('setCustomerName', value);
    },
    setCustomerAlias({ commit }, value) { 
        commit('setCustomerAlias', value);
    },
    setCustomerAliasTemp({ commit }, value) { 
        commit('setCustomerAliasTemp', value);
    },
    setStatusId({ commit }, value) {
        commit('setStatusId', value);
    },
    setEmail({ commit }, value) { 
        commit('setEmail', value);
    },
    setCustomerEmail({ commit }, value) { 
        commit('setEmail', value);
    },
    setEmailVerified({ commit }, value) { 
        commit('setEmailVerified', value);
    },
    setMobileIDD({ commit }, value) { 
        commit('setMobileIDD', value);
    },
    setMobile({ commit }, value) { 
        commit('setMobile', value);
    },
    setNationality({ commit }, value) { 
        commit('setNationality', value);
    },
    setCustomerNationality({ commit }, value) { 
        commit('setNationality', value);
    },
    setDoB({ commit }, value) { 
        commit('setDoB', value);
    },
    setGender({ commit }, value) { 
        commit('setGender', value);
    },
    setCustomerGender({ commit }, value) { 
        commit('setGender', value);
    },
    setSourceRemittance({ commit }, value) { 
        commit('setSourceRemittance', value);
    },
    setOccupation({ commit }, value) { 
        commit('setOccupation', value);
    },
    setRetailBranchId({ commit }, value) {
        commit('setRetailBranchId', value);
    },
    setResetPasswordId({ commit }, value) {
        commit('setResetPasswordId', value);
    },
    setResetPasswordFpvc({ commit }, value) {
        commit('setResetPasswordFpvc', value);
    },
    setNewPassword({ commit }, value) {
        commit('setNewPassword', value);
    },
    setOccupationList({ commit }, value) { 
        commit('setOccupationList', value);
    },
    setIsValidForm({ commit }, payload) { 
        commit('setIsValidForm', payload);
    },
    setOldEmail({ commit }, payload) { 
        commit('setOldEmail', payload);
    },
    setIsOldEmailUpdated({ commit }, payload) { 
        commit('setIsOldEmailUpdated', payload);
    },
    setIsValidAlias({ commit }, payload) { 
        commit('loadIsValidAlias', payload);
    },
    setIsModifyAlias({ commit }, payload) { 
        commit('setIsModifyAlias', payload);
    },
    setNotifInboxList({ commit }, payload) { 
        commit('setNotifInboxList', payload);
    },
    setNotifUnreadInboxList({ commit }, payload) { 
        commit('setNotifUnreadInboxList', payload);
    },
    setNotifReadInboxList({ commit }, payload) { 
        commit('setNotifReadInboxList', payload);
    },
    setNotifHasMoreItems({ commit }, payload) { 
        commit('setNotifHasMoreItems', payload);
    },
    setNotifShowLoadingBar({ commit }, payload) { 
        commit('setNotifShowLoadingBar', payload);
    },
    setNotifAllowInfinite({ commit }, payload) { 
        commit('setNotifAllowInfinite', payload);
    },
    setNotifLastItem({ commit }, payload) { 
        commit('setNotifLastItem', payload);
    },
    setNotifItemPerPage({ commit }, payload) { 
        commit('setNotifItemPerPage', payload);
    },
    setNotifLoadingFirstItem({ commit }, payload) { 
        commit('setNotifLoadingFirstItem', payload);
    },
    setNotifIsRead({ commit }, payload) { 
        commit('setNotifIsRead', payload);
    },
    setNotifSelectedMessageId({ commit }, payload) { 
        commit('setNotifSelectedMessageId', payload);
    },

    async launchNotification({ dispatch, state }){
        Vue.showPreloader();
        dispatch('setNotifUnreadInboxList', []);
        dispatch('setNotifReadInboxList', []);
        dispatch('setNotifIsRead', 0);

        dispatch('getNotificationList', {firstIndex: 0, limit: state.notification.itemPerPage, isRead: state.notification.isRead });
        //dispatch('loadNotification');
    },

    async getNotificationList({ dispatch, state }, payload){
        dispatch('setNotifInboxList', []);

        if(state.notification.loadingFirstItem){
            Vue.showPreloader();
        }
        try {
            const result =  await this.$api.customer.getInboxMessage(payload.firstIndex, payload.limit, payload.isRead);
            dispatch('setNotifInboxList', result);
            dispatch('setNotifLoadingFirstItem', false);
            dispatch('setNotifShowLoadingBar', false);

            await dispatch('loadNotification');
            Vue.hidePreloader();
        } catch (error) {
            console.log(error);
            dispatch('setNotifLoadingFirstItem', false);
            dispatch('setNotifShowLoadingBar', false);
            Vue.hidePreloader();
        }
    },

    loadNotification({ dispatch, state }){
        if(state.notification.inboxList != undefined && state.notification.inboxList.length >0){

            for(let i=0; i < state.notification.inboxList.length; i++) {

                var formattedDate = Vue.getDateFormat(state.notification.inboxList[i].dateCreated,false)
                if(state.notification.isRead == 0){
                    let isExist = state.notification.unreadInboxList.find( vendor => vendor['id'] === state.notification.inboxList[i].id );
                    if(isExist===undefined){
                        state.notification.unreadInboxList.push({'id':state.notification.inboxList[i].id, 'date':formattedDate, 'title':state.notification.inboxList[i].title, 'subject':state.notification.inboxList[i].subject, 'content':state.notification.inboxList[i].content, 'read':state.notification.inboxList[i].read});
                    }
             } else{
                    let isExist = state.notification.readInboxList.find( vendor => vendor['id'] === state.notification.inboxList[i].id );
                    if(isExist===undefined){
                        state.notification.readInboxList.push({'id':state.notification.inboxList[i].id, 'date':formattedDate, 'title':state.notification.inboxList[i].title, 'subject':state.notification.inboxList[i].subject, 'content':state.notification.inboxList[i].content, 'read':state.notification.inboxList[i].read});
                    }
            }
            }

            dispatch('setNotifAllowInfinite', true);
            dispatch('setNotifHasMoreItems', (state.notification.isRead == 0 || (state.notification.isRead == 1 && state.notification.inboxList.length >= state.notification.itemPerPage)));

            state.notification.lastItem += state.notification.inboxList.length;

            if(state.notification.isRead == 0 && state.notification.inboxList.length < state.notification.itemPerPage){ // immeadiately load more items if unread messages count is less than 10
                state.notification.isRead = 1;
                state.notification.lastItem = 0;

                dispatch('getNotificationList', {firstIndex: state.notification.lastItem, limit: state.notification.itemPerPage, isRead: state.notification.isRead })
                //dispatch('loadNotification');
            }
        }else{
            if(state.notification.isRead == 0){
                state.notification.isRead = 1; //Now fetch read messages
                state.notification.lastItem = 0,
                dispatch('getNotificationList', {firstIndex: state.notification.lastItem, limit: state.notification.itemPerPage, isRead: state.notification.isRead })
                //dispatch('loadNotification');
            }else{
                dispatch('setNotifAllowInfinite', false);
            }
        }

    },
    setLatestTx({ commit }, value) { 
        commit('setLatestTx', value);
    },
    setDateCreated({ commit }, value) { 
        commit('setDateCreated', value);
    },
    setLastFxCalcCurrencyId({ commit }, value) { 
        commit('setLastFxCalcCurrencyId', value);
    },
    setTxDestList({ commit }, value) { 
        commit('setTxDestList', value);
    },
    setTempUpdateAccountToken({ commit }, value) { 
        commit('setTempUpdateAccountToken', value);
    },
    setTempUpdateAccountType({ commit }, value) { 
        commit('setTempUpdateAccountType', value);
    },
    setTempUpdateAccountData({ commit }, value) { 
        commit('setTempUpdateAccountData', value);
    },
    setUpdateTempCurrMobileCountryCode({ commit }, value) { 
        commit('setUpdateTempCurrMobileCountryCode', value);
    },
    setUpdateTempCurrMobileNo({ commit }, value) { 
        commit('setUpdateTempCurrMobileNo', value);
    },
    setUpdateTempNewMobileCountryCode({ commit }, value) { 
        commit('setUpdateTempNewMobileCountryCode', value);
    },
    setUpdateTempNewMobileNo({ commit }, value) { 
        commit('setUpdateTempNewMobileNo', value);
    },
    setUpdateTempNewEmail({ commit }, value) { 
        commit('setUpdateTempNewEmail', value);
    },
    setUpdateTempConfirmNewEmail({ commit }, value) { 
        commit('setUpdateTempConfirmNewEmail', value);
    },
    
}

const mutations = {
    resetCustomerState (state) {
        Object.assign(state, getDefaultState())
        console.log("DONE RESET CUSTOMER STORE")
    },
    setUpdateCustomerName(state, payload) {
        state.update.customerName = payload;
    },
    setUpdateCustomerAlias(state, payload) {
        state.update.customerAlias = payload;
    },
    setUpdateNationality(state, payload) {
        state.update.nationalityId = payload.id;
        state.update.nationality   = payload.name;
    },
    setUpdateGender(state, payload) {
        state.update.gender = payload;
    },
    setUpdateDob(state, payload) {
        state.update.dob = payload;
    },
    setUpdateIdType(state, payload) {
        state.update.idTypeId = payload.id;
        state.update.idType   = payload.name;
    },
    setUpdateIdNo(state, payload) {
        state.update.idNo = payload;
    },
    setUpdateOccupation(state, payload) {
        state.update.occupation = payload;
    },
    setUpdateEmploymentSector(state, payload) {
        state.update.employmentSector = payload;
    },
    setUpdateIndustryList(state, payload) {
        state.update.industryList = payload;
    },
    setCustomerName(state, payload) {
        state.customerName = payload;
    },
    setCustomerAlias(state, payload) {
        state.customerAlias = payload;
    },
    setCustomerAliasTemp(state, payload) {
        state.customerAliasTemp = payload;
    },
    setStatusId(state, payload) {
        state.statusId = payload;
    },
    setEmail(state, payload) {
        state.email = payload;
    },
    setEmailVerified(state, payload) {
        state.emailverified = payload;
    },
    setMobileIDD(state, payload) {
        state.mobileCountryId = payload.id;
        state.mobileCountryCode = payload.name;
    },
    setMobile(state, payload) {
        state.mobile = payload;
    },
    setNationality(state, payload) {
        state.nationalityId = payload.id;
        state.nationality = payload.name;
    },
    setDoB(state, payload) {
        state.dob = payload;
    },
    setGender(state, payload) {
        state.gender = payload;
    },
    setSourceRemittance(state, payload) {
        state.sourceRemittance = payload;
    },
    setOccupation(state, payload) {
        state.occupation = payload;
    },
    setRetailBranchId(state, payload) {
        state.retailBranchId = payload;
    },
    setResetPasswordId(state, payload) {
        state.resetPasswordId = payload;
    },
    setResetPasswordFpvc(state, payload) {
        state.resetPasswordFpvc = payload;
    },
    setNewPassword(state, payload) {
        state.newPassword = payload;
    },
    setOccupationList(state, payload){
        state.occupationList = payload
    },
    setIsValidForm(state, payload){
        state.isValidForm = payload
    },
    setOldEmail(state, payload){
        state.oldEmail = payload
    },
    setIsOldEmailUpdated(state, payload){
        state.isOldEmailUpdated = payload
    },
    setIsModifyAlias(state, payload){
        state.isModifyAlias = payload
    },

    loadCheckPreventOnlySpecial(state, isValidCheckOnlySpecial) {
        state.isValidCheckOnlySpecial = isValidCheckOnlySpecial;
    },
    loadIsValidFullname(state, isValidFullname) {
        state.isValidFullname = isValidFullname;
    },
    loadIsValidAlias(state, isValidAlias) {
        state.isValidAlias = isValidAlias;
    },
    loadIsValidNationality(state, isValidNationality) {
        state.isValidNationality = isValidNationality;
    },
    loadIsValidGender(state, isValidGender) {
        state.isValidGender = isValidGender;
    },
    loadIsValidDob(state, isValidDob) {
        state.isValidDob = isValidDob;
    },
    loadIsValidIdType(state, isValidIdType) {
        state.isValidIdType = isValidIdType;
    },
    loadIsValidIdNo(state, isValidIdNo) {
        state.isValidIdNo = isValidIdNo;
    },
    loadIsValidOccupation(state, isValidOccupation) {
        state.isValidOccupation = isValidOccupation;
    },
    loadIsValidEmploymentSector(state, isValidEmploymentSector) {
        state.isValidEmploymentSector = isValidEmploymentSector;
    },
    loadIsValidForm(state, isValidForm) {
        console.log("IS VALID FORM : "+isValidForm)
        state.isValidForm = isValidForm;
    },
    setNotifInboxList(state, payload) {
        state.notification.inboxList = payload;
    },
    setNotifUnreadInboxList(state, payload) {
        state.notification.unreadInboxList = payload;
    },
    setNotifReadInboxList(state, payload) {
        state.notification.readInboxList = payload;
    },
    setNotifHasMoreItems(state, payload) {
        state.notification.hasMoreItems = payload;
    },
    setNotifShowLoadingBar(state, payload) {
        state.notification.showLoadingBar = payload;
    },
    setNotifAllowInfinite(state, payload) {
        state.notification.allowInfinite = payload;
    },
    setNotifLastItem(state, payload) {
        state.notification.lastItem = payload;
    },
    setNotifItemPerPage(state, payload) {
        state.notification.itemPerPage = payload;
    },
    setNotifLoadingFirstItem(state, payload) {
        state.notification.loadingFirstItem = payload;
    },
    setNotifIsRead(state, payload) {
        state.notification.isRead = payload;
    },
    setNotifSelectedMessageId(state, payload) {
        state.notification.selectedMessageId = payload;
    },
    setLatestTx(state, payload) {
        state.latestTx = payload;
    },
    setDateCreated(state, payload) {
        state.dateCreated = payload;
    },
    setLastFxCalcCurrencyId(state, payload) {
        state.lastFxCalcCurrencyId = payload;
    },
    setTxDestList(state, payload) {
        state.txDestList = payload;
    },
    setTempUpdateAccountToken(state, payload) {
        state.tempUpdateAccountToken = payload;
    },
    setTempUpdateAccountType(state, payload) {
        state.tempUpdateAccountType = payload;
    },
    setTempUpdateAccountData(state, payload) {
        state.tempUpdateAccountData = payload;
    },
    setUpdateTempCurrMobileCountryCode(state, payload) {
        state.update.tempCurrMobileCountryCodeId = payload.id;
        state.update.tempCurrMobileCountryCodeIdd = payload.idd;
    },
    setUpdateTempCurrMobileNo(state, payload) {
        state.update.tempCurrMobileNo = payload;
    },
    setUpdateTempNewMobileCountryCode(state, payload) {
        state.update.tempNewMobileCountryCodeId = payload.id;
        state.update.tempNewMobileCountryCodeIdd = payload.idd;
    },
    setUpdateTempNewMobileNo(state, payload) {
        state.update.tempNewMobileNo = payload;
    },
    setUpdateTempNewEmail(state, payload) {
        state.update.tempNewEmail = payload;
    },
    setUpdateTempConfirmNewEmail(state, payload) {
        state.update.tempConfirmNewEmail = payload;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}